import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';
import type { M365Acquisition } from 'owa-graph-schema';

export interface OnAcquisitionsRefreshedActionMessage {
    mailboxInfo: MailboxInfo;
    acquisitions: M365Acquisition[];
}

const onAcquisitionsRefreshed: (
    mailboxInfo: MailboxInfo,
    acquisitions: M365Acquisition[]
) => OnAcquisitionsRefreshedActionMessage = action(
    'onAcquisitionsRefreshed',
    (
        mailboxInfo: MailboxInfo,
        acquisitions: M365Acquisition[]
    ): OnAcquisitionsRefreshedActionMessage => ({
        mailboxInfo,
        acquisitions,
    })
);
export default onAcquisitionsRefreshed;
